<template>
  <md-card class="card-content">
    <md-card-header class="md-card-header-text md-card-header-green">
      <div class="card-text">
        <h4 class="title text-lg">
          {{ $t("attendance_report.student.block_terms_detail_title") }}
        </h4>
      </div>
    </md-card-header>
    <md-card-content class="p-0">
      <yv-index
        :data-source="formattedTableData"
        :columns="columns"
        :inlineSearchAction="true"
        :tableActionsComponent="TableActions"
        :paginationCfg="{
          perPage: 20,
          total: formattedTableData.length,
          hidePerPageOptions: true
        }"
        :hideBulkAction="true"
        :hideNoNumber="true"
        class="enrolled-table"
      ></yv-index>
    </md-card-content>

    <common-modal
      height="auto"
      width="70%"
      :name="attendanceViewModalProps.name"
      :title="attendanceViewModalProps.title"
      class="attendances-view-modal"
      :hideFooter="true"
    >
      <template #modal-body>
        <md-table>
          <md-table-row>
            <md-table-head>
              <p class="cell date-time-cell font-semibold">
                {{ $t("common.date_time") }}
              </p>
            </md-table-head>
            <md-table-head>
              <p class="cell status-cell font-semibold">
                {{ $t("common.status") }}
              </p>
            </md-table-head>
            <md-table-head>
              <p class="cell status-cell font-semibold">
                {{ $t("smi_sri.comment") }}
              </p>
            </md-table-head>
          </md-table-row>
          <md-table-row
            v-for="(attendance, idx) in attendanceViewModalProps.content
              .attendances"
            :key="idx"
          >
            <md-table-cell>
              <p class="cell date-time-cell">
                {{ attendance.dateTime }}
              </p></md-table-cell
            >
            <md-table-cell>
              <p class="cell status-cell">
                {{ attendance.status }}
              </p>
            </md-table-cell>
            <md-table-cell>
              <p class="cell status-cell">
                {{ attendance.comment }}
              </p>
            </md-table-cell>
          </md-table-row>
        </md-table>
      </template>
    </common-modal>
  </md-card>
</template>

<script>
import YvIndex from "@/components/Base/YvIndex.vue";
import { TEACHER_ASSIGNMENTS } from "@/constants";
import { getId } from "@/helpers/utils";
import TableActions from "./TableActions.vue";

export default {
  components: { YvIndex },
  name: "EnrolledClassesTable",
  props: ["tableData"],
  data() {
    return {
      columns: {
        class_name: this.$t(
          "attendance_report.student.enrolled_classes_table_col_name"
        ),
        subject: this.$t(
          "attendance_report.student.enrolled_classes_table_col_subject"
        ),
        primary_teacher: this.$t(
          "attendance_report.student.enrolled_classes_table_col_primary_teacher"
        ),
        status: this.$t(
          "attendance_report.student.enrolled_classes_table_col_status"
        ),
        present: this.$t("attendance_report.student.present"),
        ex_tardy: this.$t("attendance_report.student.excused_tardy"),
        ex_absence: this.$t("attendance_report.student.excused_absence"),
        unex_tardy: this.$t("attendance_report.student.unexcused_tardy"),
        unex_absence: this.$t("attendance_report.student.unexcused_absence")
      },
      TableActions,
      attendanceViewModalProps: {
        name: "Attendance View Modal",
        title: "Attendance detail: [Class name]",
        content: {
          attendances: []
        }
      }
    };
  },
  computed: {
    formattedTableData() {
      if (!this.tableData) return [];
      return this.tableData.map(classObj => ({
        id: getId(classObj),
        class_name: classObj.name,
        subject: classObj.subject?.name,
        primary_teacher: this.getPrimaryTeacherUsn(classObj.teachers),
        status: this.generateStatusColHTML(classObj.status),
        ...this.getAttdFields(classObj)
      }));
    }
  },
  methods: {
    getPrimaryTeacherUsn(teachers) {
      if (!teachers || !teachers.length) return "";

      const primaryTeacher = teachers.find(
        teacher => teacher.assignment === TEACHER_ASSIGNMENTS.PRIMARY
      );

      return primaryTeacher?.users?.username;
    },
    getAttdFields(classObj) {
      const { attendances } = classObj;

      if (!attendances || !attendances.length) return {};

      return attendances.reduce((attdFieldsObj, attdObj) => {
        const attdFieldKey = this.getAttdFieldKeyFromTitle(attdObj.status);
        const attdFieldValue = attdObj.count;

        return {
          ...attdFieldsObj,
          [attdFieldKey]: `<p class="text-center pr-5">${attdFieldValue}</p>`
        };
      }, {});
    },
    getAttdFieldKeyFromTitle(attdStatus) {
      return attdStatus.toLowerCase().replace(/\./g, "_");
    },
    generateStatusColHTML(status) {
      const statusClass = status.toLowerCase() || "on-going";
      return `<p class="rounded-[40px] py-[5px] px-[15px] uppercase font-medium text-base w-max ${statusClass}">${status}</p>`;
    },
    viewAttendances(className, attendances) {
      this.attendanceViewModalProps.title = `Attendance detail: ${className}`;
      this.attendanceViewModalProps.content.attendances = [...attendances];
      this.$nextTick(() => {
        this.$modal.show(this.attendanceViewModalProps.name);
      });
    }
  },
  provide() {
    return {
      viewAttendances: this.viewAttendances
    };
  }
};
</script>

<style lang="scss">
$on-going-color: #2f80ed;
$concluded-color: #3eaa86;

.on-going {
  color: $on-going-color;
  background: rgba($on-going-color, 0.2);
}
.concluded {
  color: $concluded-color;
  background: rgba($concluded-color, 0.2);
}

.attendances-view-modal {
  &__table {
    .row {
      @apply flex items-center border-b p-4;

      .cell {
        @apply m-0 text-sm;
      }

      .date-time-cell {
        width: 80%;
      }

      .status-cell {
        width: 20%;
      }
    }
  }
}
</style>
